import { AfterViewInit, ChangeDetectorRef, Component, Inject } from '@angular/core';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import {
  AbstractControl,
  FormControl,
  ReactiveFormsModule,
  ValidationErrors,
  ValidatorFn,
  Validators
} from '@angular/forms';
import { UtilsProvider } from "../../../common/providers/utils-provider.service";
import { ConfigProvider } from "../../../config-provider.service";
import { UsersProvider } from '../../providers/users-provider';
import { CurrentUser } from "../../../common/providers/current-user";
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent, MatDialogModule,
  MatDialogRef
} from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatError, MatFormField } from "@angular/material/form-field";
import { NgIf } from "@angular/common";
import { MatInput } from "@angular/material/input";
import { MatButton } from "@angular/material/button";
import { MatProgressBar } from "@angular/material/progress-bar";
import { User } from "../../../common/models/user";
import { EMPTY, map, Observable } from "rxjs";
import { catchError } from "rxjs/operators";

@Component({
  selector: 'users-change-password-dialog',
  providers: [],
  styleUrls: ['./change-email-dialog.scss'],
  standalone: true,
  imports: [
    TranslateModule,
    MatFormField,
    NgIf,
    MatDialogModule,
    MatInput,
    ReactiveFormsModule,
    MatButton,
    MatProgressBar,
    MatError,
  ],
  templateUrl: './change-email-dialog.html'
})
export class UsersChangeEmailDialogComponent {
    public isLoading = false;
    public emailUnavailableError = false;

    public currentEmailFormControl: FormControl = new FormControl({value: '', disabled: true});
    public newEmailFormControl: FormControl = new FormControl('', [
      Validators.required,
      Validators.email,
      (control: any) => this.emailUnavailableError ? { unavailable: { valid: false } } : null
    ]);

    public user: User = {} as User;
    constructor(
        public conf: ConfigProvider,
        public currentUser: CurrentUser,
        public dialog: MatDialogRef<UsersChangeEmailDialogComponent>,
        public utils: UtilsProvider,
        private translater: TranslateService,
        private toaster: MatSnackBar,
        private usersProvider: UsersProvider,
        @Inject(MAT_DIALOG_DATA) private data : any
    ) {
        this.user = data.user;
        this.currentEmailFormControl.setValue(this.user.email);
    }


    public onSaveClicked(): void {
        this.isLoading = true;
        this.save().subscribe({
            next: (result) => {
                this.toaster.open(this.translater.instant('Email_update_sent', {email: this.newEmailFormControl.value}), '', { duration: 5000 });
                this.isLoading = false;
                this.dialog.close(result);
            },
            error: (error) => this.onError(error)
        });
    }


    private save(): Observable<any> {
      return this.usersProvider.changeEmail({newEmail: this.newEmailFormControl.value}).pipe(
        map((data: any) => {
          this.isLoading = false;
          return data;
        }),
      );
    }

    public onNewEmailEnter() {
      // call api to check if email is available
      this.usersProvider.checkEmailAvailability({email: this.newEmailFormControl.value, deep: true}).subscribe({
        next: (result) => {
          console.log('result', result);
          this.emailUnavailableError = !result;
          this.newEmailFormControl.updateValueAndValidity();
        }
      });
    }

    private onError(error: any): void {
        this.isLoading = false;

        if (error.status === 401) {
            return;
        }

        this.toaster.open(this.translater.instant('Error_unknown'), '', { duration: 5000 });
    }

}
